const infiniteBlogScroll = (initialData: any[]) => ({
  selectedCategory: null as number | null,
  allBlogs: initialData,
  visibleBlogs: [] as any[],
  sortBy: "dateDesc",
  page: 1,
  itemsPerPage: 10,
  loadMoreCount: 5,
  observer: null as IntersectionObserver | null,

  handleCategoryChange() {
    const filteredItems = this.selectedCategory
      ? this.allBlogs.filter(
          (blog) => blog.categoryId === this.selectedCategory
        )
      : this.allBlogs;
    this.visibleBlogs = filteredItems;
    this.sortBlogs();
  },

  init() {
    this.visibleBlogs = this.allBlogs.slice(0, this.itemsPerPage);
    this.setupIntersectionObserver();
    this.sortBlogs();
  },

  setupIntersectionObserver() {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.1,
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.loadMore();
        }
      });
    }, options);

    setTimeout(() => {
      const trigger = document.querySelector(
        '[x-ref="scrollTrigger"]'
      ) as HTMLElement;
      if (this.observer && trigger) {
        this.observer.observe(trigger);
      }
    }, 0);
  },

  loadMore() {
    const start = this.visibleBlogs.length;
    const end = start + this.loadMoreCount;
    const nextItems = this.allBlogs.slice(start, end);

    if (nextItems.length) {
      this.visibleBlogs.push(...nextItems);
      this.page++;
      this.sortBlogs();
    }
  },

  sortBlogs() {
    this.visibleBlogs.sort((a, b) => {
      switch (this.sortBy) {
        case "dateAsc":
          return a.rawDate - b.rawDate;
        case "dateDesc":
          return b.rawDate - a.rawDate;
        case "titleAsc":
          return a.title.localeCompare(b.title);
        case "titleDesc":
          return b.title.localeCompare(a.title);
      }
    });
  },
});

export default infiniteBlogScroll;
